
import './Services.css';
import FlightModal from './FlightModal';
import React from 'react';
const Services = () => {
    const [showFlightModal, setShowFlightModal] = React.useState(false);

    console.log(showFlightModal);
    return (
  <section id="services" className="services">
    <h2 style={{ textAlign: 'center', fontSize: '2.3rem', color: '#2E3387', marginBottom: '2.5rem', letterSpacing: '0.01em' }}>Our Services</h2>
    <div className="services-grid">
      <div className="service-card">
        <i className="fas fa-plane"></i>
        <h3>Flight Ticketing</h3>
        <p>Book flights to any destination worldwide with our best prices guarantee</p>
        <ul className="service-features">
          <li>International & Domestic Flights</li>
          <li>Group Booking Discounts</li>
          <li>24/7 Flight Support</li>
          <li>Best Price Guarantee</li>
        </ul>
        <button className="service-button" onClick={() => setShowFlightModal(true)}>Book Flights</button>
      </div>
      <div className="service-card">
        <i className="fas fa-hotel"></i>
        <h3>Hotel Bookings</h3>
        <p>Find and book accommodations from luxury hotels to cozy apartments</p>
        <ul className="service-features">
          <li>Worldwide Hotel Network</li>
          <li>Exclusive Hotel Deals</li>
          <li>Last Minute Bookings</li>
          <li>Special Corporate Rates</li>
        </ul>
        <button className="service-button">Coming Soon</button>
      </div>
      <div className="service-card">
        <i className="fas fa-car"></i>
        <h3>Car Rentals</h3>
        <p>Rent vehicles for your journey with our trusted car rental partners</p>
        <ul className="service-features">
          <li>Wide Range of Vehicles</li>
          <li>Competitive Rates</li>
          <li>Insurance Coverage</li>
          <li>24/7 Roadside Assistance</li>
        </ul>
        <button className="service-button">Coming Soon</button>
      </div>
      <div className="service-card">
        <i className="fas fa-route"></i>
        <h3>Tourism & Tours</h3>
        <p>Explore exciting destinations with our guided tours and packages</p>
        <ul className="service-features">
          <li>Guided City Tours</li>
          <li>Adventure Packages</li>
          <li>Cultural Experiences</li>
          <li>Custom Tour Planning</li>
        </ul>
        <button className="service-button">Coming Soon</button>
      </div>
      <div className="service-card">
        <i className="fas fa-passport"></i>
        <h3>Visa Services</h3>
        <p>Professional visa assistance for hassle-free travel</p>
        <ul className="service-features">
          <li>Visa Application Support</li>
          <li>Document Verification</li>
          <li>Express Processing</li>
          <li>Visa Consultation</li>
        </ul>
        <button className="service-button">Coming Soon</button>
      </div>
    </div>
    {showFlightModal && (
      <div className="flight-modal-overlay" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(46,51,135,0.18)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }}>
        <FlightModal show={true} onClose={() => setShowFlightModal(false)} />
      </div>
    )}
  </section>
  );
}

export default Services;
